
export default {
	name: "ScalePage",
	data() {
		return {
			title: "Porto Design Biennale",
			porto: "Porto",
			design: "Design",
			biennale: "Biennale",
			year: "2019",
			titleRendered: "Porto Design Biennale",
			portoRendered: null,
			designRendered: null,
			biennaleRendered: null,
			yearRendered: null,

			showYear: false,
			border: false,
			noType: false,
			isAnimated: false,
			blackBox: false,
			lineFull: true,
		}
	},
	created() {
		this.titleSplit();
	},
	computed: {
		pageUrl: function () {
			return location.href;
		}
	},
	mounted() {
		// this.weightChange();
		this.logoVar();
	},
	methods: {
		titleSplit() {
			this.portoRendered = this.porto.split('');
			this.designRendered = this.design.split('');
			this.biennaleRendered = this.biennale.split('');
			this.yearRendered = this.year.split('');
		},
		logoVar() {
			let logo = document.getElementById("logo-random").children;
			let random = 1; let randomClass = 1;

			setInterval( () => {
				random = Math.floor((Math.random() * 6) + 1);
				
				if(this.isAnimated) {
					for (let i = 0; i < logo.length; ) {
						let word = logo[i]
						
						for (let j = 0; j < word.children.length; ) {
							const element = word.children[j];
							// console.log("element", element.classList.contains( "logo__fill" ) )
							
							if( element.classList.contains("logo__fill") == false ) {
								
								randomClass = Math.floor((Math.random() * 6) + 1);
								element.classList.remove("animation-1", "animation-2", "animation-3", "animation-4", "animation-5", "animation-6")
								
								if (element.children[0].innerHTML == "n") {
									// console.log("N")
									if (randomClass == 1 || randomClass == 2 || randomClass == 3)
										element.classList.add("animation-5")
									if (randomClass == 4 || randomClass == 5 || randomClass == 6)
										element.classList.add("animation-4")
								}
								else
									element.classList.add("animation-" + randomClass)
							}
							j++;
						}
						i++;
					}
				}
			}, random * 1000 );
		},
		textChange() {
			let logo = document.getElementById("logo-random");
			if(this.lineFull) {
				this.porto = "P";
				this.design = "D";
				this.biennale = "B";
				console.log("Document", logo);
				logo.classList.add("logo--flex");
			} else {
				console.log("PDB")
				this.porto = "Porto";
				this.design = "Design";
				this.biennale = "Biennale";
				logo.classList.remove("logo--flex");
			}
			
			this.titleSplit();
			
			console.log("lineFull?", this.lineFull)
			this.lineFull = !this.lineFull;
		},
	}
}



// WEBPACK FOOTER //
// ./src/components/pages/random/random.page.js